<template>
  <v-container  fluid fill-height style="" class="bg white--text">
    <v-row class="text-center" align="center" justify="center">
      <v-col class="mb-4" cols="10">
        <h1 class="display-1 font-weight-bold mb-3 " style="">
          Create a choose your own adventure story that your friends can add to!
        </h1>

      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >
        <v-row justify="center">
          <v-card
            class="mx-auto text-center"
            min-width="340px"
            min-height="20px"
          >
          <v-container  >
            <v-row align="center"
                justify="center">
                    <v-btn class="success" xLarge to="/create">
                      Start your own story
                      <v-icon>{{ mdiArrowRightBold }}</v-icon>
                    </v-btn>

            </v-row>
            <v-row align="center" justify="center" class="mt-4">
              <router-link :to="{ name: 'HowItWorks' }" class="title">How does this work?</router-link>
            </v-row>
            <v-row align="center" justify="center" class="mt-4">
              <a href="https://addtothestory.com/story/eOpxGFkETLBg8ed7QXQH?pw=KiIEe8Ez5pDEE1gSQ2z1"
               class="title">Read a sample story
             </a>
            </v-row>

            <v-row align="center" justify="center" class="subheading font-weight-regular mt-4">
                <span>
                  Contact <a href='mailto:dan@addtothestory.com'>dan@addtothestory.com</a> for help.
                </span>
            </v-row>
          </v-container>
          </v-card>
        </v-row>
      </v-col>
      <!-- v-col>
        <p class="subheading font-weight-regular">
          Contact me <a href='mailto:dan@addtothestory.com'>dan@addtothestory.com</a> for help.
        </p></v-col-->
    </v-row>
  </v-container>
</template>

<script>
import { mdiArrowRightBold } from '@mdi/js'

export default {
  name: 'HelloWorld',

  data: () => ({
    mdiArrowRightBold: mdiArrowRightBold,
    valid: false,
    storyID: '',
    idRules: [
      v => !!v || 'ID is required',
      v => v.length <= 30 || 'Name must be less than 30 characters'
    ]
  }),

  methods: {
    validate () {
      this.valid = this.$refs.form.validate()
      if (this.valid) {
        // Check if the story exists, if so go to it.
        this.$router.push({ name: 'ReadStory', params: { storyID: this.storyID, pageID: null } })
      }
    }

  }
}
</script>
<style scoped>
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    /* background: url( '../assets/background.jpg') no-repeat center center; */

    background: rgb(25,118,210);
    background: radial-gradient(circle, rgba(25,118,210,1) 0%, rgba(96,69,208,1) 100%);

    background-size: cover;
    background-color: red;
    transform: scale(1.1);
  }
</style>
